import React, { Component } from 'react';
import { withContext } from '../utils/StateProvider';
import { formatDuration } from '../utils/rng';

// Level number and elapsed time for the run in progress. Keeps its own timer
// so ticking the clock doesn't re-render the rest of the game.
class RunClock extends Component {
  state = { now: Date.now() };

  componentDidMount() {
    this.timer = setInterval(() => this.setState({ now: Date.now() }), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const { run } = this.props.context;
    if (!run) return null;
    return (
      <span className="run-clock">
        LEVEL {run.level}/{run.levels}
        <span className="run-time">{formatDuration(this.state.now - run.startedAt)}</span>
      </span>
    );
  }
}

export default withContext(RunClock);
